<template>
  <v-chip :color="statusColor" size="small" variant="tonal">
    {{ statusLabel }}
  </v-chip>
</template>

<script>
export default {
  name: 'StatusChipComp',

  props: {
    status: {
      type: String,
      default: ''
    },
  },

  computed: {
    statusLabel () {
      if (!this.status) return '—'
      return this.$t(String(this.status).toUpperCase())
    },

    statusColor () {
      switch (this.status) {
        case 'pending':
          return 'warning'
        case 'active':
          return 'success'
        case 'suspended':
          return 'error'
        case 'healthy':
          return 'success'
        case 'degraded':
          return 'warning'
        case 'failing':
          return 'error'
        default:
          return 'grey'
      }
    }
  },
}
</script>
